import React, { memo } from 'react'
import { array, string } from 'prop-types'
import styled from 'styled-components'
import { Text } from '@components'
import { Row, Col, Container } from '@mch-group/uikit-components'
import cssClasses from '@constants/cssClasses'
import EventCardList from '@components/ot-modules/Events/components/EventCardList'

// @ts-ignore
const BrowseEvents = memo(({ eventsList, noEventsLabel, slug }) => {
  if (!eventsList) {
    return null
  }

  if (eventsList && eventsList.length === 0 && slug !== '/events/attending') {
    return (
      <Text isHtml className={cssClasses.CMS_MODULE}>
        {noEventsLabel || 'There are no events.'}
      </Text>
    )
  }

  return (
    <ContainerStyled>
      {eventsList.length ? (
        <Row className='g-5 g-md-6 g-xl-7'>
          {eventsList.map((event, i) => (
            <Col key={Math.random()} xs={12} sm={12} md={6} lg={6} xl={3} xxl={3} className='mb-lg-8 mb-md-8 d-flex'>
              <EventCardList
                // @ts-ignore
                index={i}
                item={event}
                isCollectionCard={false}
              />
            </Col>
      ))}
        </Row>
    ) : null}
    </ContainerStyled>
  )
})
BrowseEvents.displayName = 'BrowseEvents'

// @ts-ignore
BrowseEvents.propTypes = {
  eventsList: array,
  noEventsLabel: string,
  slug: string
}

const ContainerStyled = styled(Container)`
  @media (max-width: 992px) {
    .image-frame > button {
      display: none;
    }
  }
`

export default BrowseEvents
